import { createContext, useContext } from 'react';

/*
 * Ant Design `Table` `sticky` config, shared from the AppShell so every
 * page-level table keeps its column headers pinned while its scroll container
 * scrolls. The scroll container differs by layout: on desktop it is the
 * `Layout.Content` div (an `overflow:auto` box), so we hand the table a
 * `getContainer` pointing at it; on mobile the window scrolls under a fixed
 * app header, so we only offset the header by its height. Tables rendered
 * inside a Drawer (their own scroll container) should NOT use this.
 */
export type TableSticky =
  | boolean
  | {
      offsetHeader?: number;
      offsetScroll?: number;
      offsetSummary?: number;
      getContainer?: () => Window | HTMLElement;
    };

const StickyTableContext = createContext<TableSticky | undefined>(undefined);

export const StickyTableProvider = StickyTableContext.Provider;

export const useStickyTable = (): TableSticky | undefined => useContext(StickyTableContext);
